var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "credit-limit-banner"
  }, [_c("el-tag", {
    attrs: {
      type: _vm.creditAvailableNow >= 0 ? "success" : "danger",
      size: "medium"
    }
  }, [_vm._v(" Credit Available: " + _vm._s(_vm.creditAvailableNow.toFixed(2)) + " ")]), _c("el-tag", {
    attrs: {
      type: "info",
      size: "medium"
    }
  }, [_vm._v(" Effective Credit Limit: " + _vm._s(_vm.effectiveAvailable.toFixed(2)) + " ")]), _c("span", {
    staticClass: "credit-detail"
  }, [_vm._v(" (Current Order Total: " + _vm._s(_vm.currentOrderTotal.toFixed(2)) + ") ")])], 1), _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      fit: "",
      "highlight-current-row": ""
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "80px",
      label: "ID",
      prop: "id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.id) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "200px",
      label: "Product",
      prop: "productName",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [!scope.row.isEditing ? _c("span", [_vm._v(_vm._s(scope.row.product.name))]) : _c("el-select", {
          attrs: {
            filterable: "",
            remote: "",
            clearable: "",
            "remote-method": query => _vm.getProductList(query, scope.row),
            loading: scope.row.productListLoading,
            placeholder: "Select Product",
            size: "mini"
          },
          on: {
            change: function ($event) {
              return _vm.handleProductSelection(scope.row);
            }
          },
          model: {
            value: scope.row.selectedProduct,
            callback: function ($$v) {
              _vm.$set(scope.row, "selectedProduct", $$v);
            },
            expression: "scope.row.selectedProduct"
          }
        }, _vm._l(scope.row.products, function (product) {
          return _c("el-option", {
            key: "product-" + product.id,
            attrs: {
              label: product.name,
              value: product.name
            }
          }, [_c("span", {
            staticStyle: {
              "font-weight": "bold"
            }
          }, [_vm._v(_vm._s(product.name))])]);
        }), 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "100px",
      label: "Variation",
      prop: "variationName",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [!scope.row.isEditing ? _c("span", [_vm._v(_vm._s(scope.row.productsVariation.name))]) : _c("el-select", {
          attrs: {
            size: "mini",
            placeholder: "Select variation"
          },
          on: {
            change: function ($event) {
              return _vm.updateVariationName(scope.row);
            }
          },
          model: {
            value: scope.row.productsVariation.id,
            callback: function ($$v) {
              _vm.$set(scope.row.productsVariation, "id", $$v);
            },
            expression: "scope.row.productsVariation.id"
          }
        }, _vm._l(scope.row.product.variations, function (variation) {
          return _c("el-option", {
            key: variation.id,
            attrs: {
              label: variation.name,
              value: variation.id
            }
          });
        }), 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "160px",
      label: "Cartons",
      prop: "numberOfCartons",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [!scope.row.isEditing ? _c("span", [_vm._v(_vm._s(scope.row.numberOfCartons))]) : _c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            max: 5000,
            step: 1,
            "step-strictly": ""
          },
          on: {
            change: function ($event) {
              return _vm.checkQuantity(scope.$index, scope.row);
            }
          },
          model: {
            value: scope.row.numberOfCartons,
            callback: function ($$v) {
              _vm.$set(scope.row, "numberOfCartons", $$v);
            },
            expression: "scope.row.numberOfCartons"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "160px",
      label: "Boxes",
      prop: "numberOfBoxes",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [!scope.row.isEditing ? _c("span", [_vm._v(_vm._s(scope.row.numberOfBoxes))]) : _c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            max: 5000,
            step: 1,
            "step-strictly": ""
          },
          on: {
            change: function ($event) {
              return _vm.checkQuantity(scope.$index, scope.row);
            }
          },
          model: {
            value: scope.row.numberOfBoxes,
            callback: function ($$v) {
              _vm.$set(scope.row, "numberOfBoxes", $$v);
            },
            expression: "scope.row.numberOfBoxes"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "160px",
      label: "Pieces",
      prop: "numberOfPieces",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            disabled: true,
            min: 0,
            step: 1,
            "step-strictly": ""
          },
          model: {
            value: scope.row.numberOfPieces,
            callback: function ($$v) {
              _vm.$set(scope.row, "numberOfPieces", $$v);
            },
            expression: "scope.row.numberOfPieces"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "80px",
      label: "MRP",
      prop: "mrp",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.mrp) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "80px",
      label: "Nett Rate",
      prop: "nettRate",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.nettRate) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      label: "Actions",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [!scope.row.isEditing ? _c("el-button", {
          attrs: {
            type: "primary",
            size: "mini"
          },
          on: {
            click: function ($event) {
              return _vm.handleEdit(scope.row);
            }
          }
        }, [_vm._v(" Edit ")]) : _c("el-button", {
          attrs: {
            type: "success",
            size: "mini"
          },
          on: {
            click: function ($event) {
              return _vm.handleSave(scope.row);
            }
          }
        }, [_vm._v(" Save ")]), scope.row.isEditing ? _c("el-button", {
          attrs: {
            type: "danger",
            size: "mini"
          },
          on: {
            click: function ($event) {
              return _vm.handleCancel(scope.row);
            }
          }
        }, [_vm._v(" Cancel ")]) : _vm._e(), _c("el-button", {
          attrs: {
            type: "danger",
            size: "mini",
            icon: "el-icon-delete",
            disabled: _vm.tableData.length <= 1
          },
          on: {
            click: function ($event) {
              return _vm.handleDelete(scope.row);
            }
          }
        })];
      }
    }])
  })], 1), _c("div", {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c("el-button", {
    attrs: {
      type: "success",
      size: "mini",
      loading: _vm.saveLoading
    },
    on: {
      click: _vm.handleSaveAll
    }
  }, [_vm._v(" Save ")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };